import { mapActions, mapGetters } from "vuex";
import { MANNING_COLORS } from "@/services/ConstantService";
import { DateService } from "@/services/Utilities/DateService";

export const dataMixin = {

    data() {
        return {

        }
    },

    methods: {
        ...mapActions([ 'downloadCrewDocument' ]),
        manningColor(manningCode) {
            return MANNING_COLORS[manningCode];
        },

        fullName(person) {
            let name = '';
            if(person) {
                if(person.last_name) name += person.last_name;
                if(person.first_name) name += ', ' +  person.first_name;
                if(person.name) name += ', ' +  person.name;
                if(person.middle_name) name += ' ' +  person.middle_name.charAt(0) + '.';
                if(person.extension) name += ' ' + person.extension;
            }
            return name;
        },

        lastnameWTinitials(person) {
            let name = '';
            if(person) {
                if(person.name) name += person.name.charAt(0) + '. ';
                if(person.first_name) name += person.first_name.charAt(0) + '. ';
                if(person.last_name) name += person.last_name;

                // if(person.last_name) name += person.last_name;
                // if(person.extension) name += ' ' + person.extension + '.';
                // if(person.name) name += ', ' +  person.name;
                // if(person.middle_name) name += ', ' +  person.middle_name.charAt(0) + '.';
            }
            return name;
        },

        crewRank(crew) {
            return crew.rank ? crew.rank.alias : '';
        },

        crewRankTitle(crew) {
            return crew.rank ? crew.rank.name : '';
        },

        initializeDownloadCrewDocument(internationalDocument) {
            let params = {
                crew: this.crew,
                crewDocument: internationalDocument
            };
            this.downloadCrewDocument(params);
        },

        parseObjectName(objects, id) {
            if(objects.length && id)
                return objects.find(object => object.id == id).name
        },

        parseObjectNameList(objects, ids, separator) {
            let nameList = '';
            if(objects.length && ids.length) {
                return objects.filter(object => ids.some(id => id == object.id))
                    .map(object => object.name)
                    .join(separator);
            }
            return '';
        },

        dateDifference(targetDate, dateOrigin = new Date()) {
            return DateService.getDateDifference(dateOrigin, this.crew.currentActivity.endDate);
        },

        dateDiff(targetDate, dateOrigin = new Date()) {
            return DateService.getDateDifference(dateOrigin, targetDate);
        }

    },

    computed: {

    }

};
